<template>
  <div>
    <specialoffer-check
      :data.sync="data"
      :sna-id="snaId"
      :cellcolor="cellcolor"
    >
      <template>
        <div
          class="item-box-content"
          style="padding:15px 20px;"
        >
          <div>
            <span
              class="bold"
              style="vertical-align: middle"
            ></span>
            <el-tabs
              v-model="activeTabName"
              @tab-click="handleClick"
              style="display: inline-block;vertical-align: middle;margin-left: 20px;"
            >
              <el-tab-pane
                :label="`特价审批`"
                :name="`a`"
              ></el-tab-pane>
              <el-tab-pane
                :label="`产品清单`"
                :name="`b`"
              ></el-tab-pane>
            </el-tabs>
            <div style="float:right;padding-top: 5px;">
              <el-button
                type="primary"
                @click="batchPassCheck"
              >批量通过
              </el-button
              >
              <el-button @click="batchRejectCheck">批量不通过</el-button>
            </div>
          </div>
          <div style="padding-top: 20px;">
            <el-table
              v-if="activeTabName === 'a'"
              ref="multipleTable"
              :data="tableData"
              border
              height="300px"
              tooltip-effect="dark"
              style="width: 100%"
              :row-style="rowClass"
              :header-cell-style="tableHeader"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column label="品牌">
                <template slot-scope="scope">{{scope.row.brandName}}</template>
              </el-table-column>
              <el-table-column
                prop="seriesName"
                label="系列"
              >
              </el-table-column>
              <el-table-column
                prop="proName"
                label="产品名称"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="proType"
                label="型号"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    @click="goProTypeDetail(scope.row)"
                    v-cust
                    style="color:#276CFF"
                  >{{ scope.row.proType }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="orderNumber"
                label="订货号"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="ocUnit"
                label="单位"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="ocNeednumber"
                label="数量"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="storageNumber"
                label="库存"
                show-overflow-tooltip
              >
              </el-table-column>
              <!--              <el-table-column-->
              <!--                prop="ocExtype"-->
              <!--                label="类型"-->
              <!--                show-overflow-tooltip-->
              <!--              >-->
              <!--              </el-table-column>-->
              <el-table-column
                prop="ocExtime"
                label="期望货期"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="specialPrice"
                label="期望价格"
                show-overflow-tooltip
              >
                <template v-slot="{ row }">
                  {{row.specialPrice | toFixedex}}
                </template>
              </el-table-column>
              <el-table-column
                prop="ocDiscount"
                label="折扣"
                show-overflow-tooltip
              >
                <template v-slot="{ row }">
                  {{row.ocDiscount | toPercentFormat}}
                </template>
              </el-table-column>
              <el-table-column
                prop="ocUnitPrice"
                label="供货单价"
                show-overflow-tooltip
              >
                <template v-slot="{ row }">
                  {{row.ocUnitPrice | toFixedex}}
                </template>
              </el-table-column>
              <el-table-column
                prop="purchaseUnitPrice"
                label="采购单价"
                show-overflow-tooltip
              >
                <template v-slot="{ row }">
                  {{row.purchaseUnitPrice | toFixedex}}
                </template>
              </el-table-column>
              <el-table-column
                prop="ocFacePrice"
                label="面价"
                show-overflow-tooltip
              >
                <template v-slot="{ row }">
                  {{row.ocFacePrice | toFixedex}}
                </template>
              </el-table-column>
              <el-table-column
                label="审批"
                width="160"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-radio
                    v-model="scope.row.state"
                    :label="1"
                    class="theme-blue"
                  >通过
                  </el-radio>
                  <el-radio
                    v-model="scope.row.state"
                    :label="0"
                    class="theme-blue"
                  >不通过
                  </el-radio
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="特价有效期"
                width="150"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-date-picker
                    style="width:100%;"
                    v-model="scope.row.specialDate"
                    type="date"
                    value-format="timestamp"
                    :picker-options="pickerOptions"
                    placeholder="选择日期"
                  >
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-input
                    placeholder="请输入备注"
                    v-model="scope.row.mark"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
            <info-table
              v-else
              :field-arr="proField"
              :table-data="tableData"
              :table-height="`300px`"
            ></info-table>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button
          type="primary"
          @click="submitCheckResult"
        >提交
        </el-button>
      </template>
    </specialoffer-check>
    <v-base-dialog
      :title="`设置特价有效期`"
      :dialog-visible.sync="specialDialog"
      @successEv="setSpecialTime"
      @cancelEv="closeDialog"
    >
      <template>
        <el-form
          :model="endform"
          label-width="120px"
        >
          <el-form-item label="截至有效期：">
            <el-date-picker
              style="width:100%;"
              v-model="endform.endTime"
              value-format="timestamp"
              type="date"
              placeholder="选择日期"
              default-time="23:59:00"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </template>
    </v-base-dialog>
    <v-base-dialog
      :title="`请填写备注`"
      :dialog-visible.sync="explanDialog"
      @cancelEv="closeDialog"
      @successEv="setSpecialExplan"
    >
      <template>
        <el-form
          :model="endform"
          label-width="70px"
        >
          <el-form-item label="备注：">
            <el-input
              type="textarea"
              v-model="endform.explan"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </v-base-dialog>
    <v-base-dialog
      :title="`提示`"
      :dialog-visible.sync="specialApprovalVis"
      @cancelEv="closeDialog"
      @successEv="submitReq"
    >
      <span style="padding:0 0 30px 26px;">提交成功后将向销售反馈相应结果</span>
    </v-base-dialog>
  </div>
</template>

<script>
import specialofferCheck from '@/views/workbench/workCheckManage/specialofferCheck/specialofferCheck'
import specialofferApi from '@/api/workbench/check'
import infoTable from '@/components/module/infoTable'
import vBaseDialog from '@/components/module/baseDialog'
import { isSuccess } from '@/util/tool'

export default {
  name: 'specialofferCheckView',
  components: {
    specialofferCheck,
    vBaseDialog,
    infoTable
  },
  provide () {
    return {
      pageTitle: '特价审批',
      type: 0
    }
  },
  props: {
    cellcolor: {
      type: String,
      default: ''
    }
  },
  filters: {
    toFixedex (n) {
      if (!n) return n
      return n.toFixed(2)
    },
    toPercentFormat (n) {
      const nex = Number(n) ? n : 0
      return (nex * 100).toFixed(2) + '%'
    }
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - (1000 * 60 * 60 * 12 * 2)
        }
      },
      specialApprovalVis: false,
      activeTabName: 'a',
      radio: '1',
      endTime: '',
      explan: '',
      endform: {},
      snaId: '',
      specialDialog: false,
      explanDialog: false,
      batchFalg: true, // 判断是点击了批量通过还是不通过
      checkSelected: [],
      data: {},
      specialProList: [],
      proField: [{
        name: 'brandName',
        label: '品牌'
      }, {
        name: 'seriesName',
        label: '系列'
      }, {
        name: 'proName',
        label: '产品名称'
      }, {
        name: 'proType',
        label: '型号'
      }, {
        name: 'orderNumber',
        label: '订货号'
      }, {
        name: 'ocNeednumber',
        label: '数量'
      }, {
        name: 'ocUnit',
        label: '单位'
      }, {
        name: 'ocExtime',
        label: '期望货期'
      }, {
        name: 'ocPrice',
        label: '单品报价'
      }, {
        name: 'ocDiscount',
        label: '折扣'
      }, {
        name: 'ocRate',
        label: '毛利率'
      }, {
        name: 'ocTotal',
        label: '总报价'
      }, {
        name: 'ocHistoryPrice',
        label: '历史单价'
      }, {
        name: 'ocUnitPrice',
        label: '供货单价'
      }, {
        name: 'ocUnitTotal',
        label: '供货总价'
      }, {
        name: 'ocUnitDate',
        label: '供货价有效期'
      }, {
        name: 'storageNumber',
        label: '当前库存'
      }, {
        name: 'ocFacePrice',
        label: '面价'
      }]
    }
  },
  computed: {
    tableData () {
      const { data, cellcolor, activeTabName } = this
      if (data.approvalState === 1 || data.systemFlowRunAuditOrgVos) {
        const name = (cellcolor === '') ? 'specialoffercheckdetail' : 'specialofferlimitcheckdetail'
        this.$router.replace({
          name,
          query: {
            bizId: this.snaId
          }
        })
      }
      if (activeTabName === 'b') {
        return this.specialProList || []
      }
      return this.data.customerSpecialPriceContentVoList || []
    }
  },
  created () {
    this.snaId = this.$route.query.bizId
  },
  methods: {
    goCheckDetail () {
      // const {snId} = this
      // this.$router.replace({
      //   name:
      // })
    },
    handleClick (param) {
      const { activeTabName, data } = this
      if (activeTabName === 'b') {
        specialofferApi.specialofferProList({
          obId: data.obId
        }).then(res => {
          this.specialProList = res.data.obj
        })
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleSelectionChange (val) {
      this.checkSelected = val
    },
    // 批量通过
    batchPassCheck () {
      this.batchFalg = true
      if (this.checkSelected.length === 0) {
        this.$message({
          message: '请先选择数据',
          type: 'error'
        })
        return
      }
      this.specialDialog = true
    },
    // 批量不通过
    batchRejectCheck () {
      this.batchFalg = false
      if (this.checkSelected.length === 0) {
        this.$message({
          message: '请先选择数据',
          type: 'error'
        })
        return
      }
      this.explanDialog = true
    },
    // 批量设置时间
    setSpecialTime () {
      const { endform } = this
      if (!endform.endTime) {
        this.$nextTick(() => {
          this.specialDialog = true
          this.$message({
            message: '请选择特价结束时间',
            type: 'error'
          })
        })
        return
      }
      this.specialDialog = false
      this.explanDialog = true
    },
    // 关闭批量dialog
    closeDialog () {
      const {
        endform,
        batchFalg
      } = this
      if (batchFalg) {
        // this.submitBatchPass(1)
      }
      for (const key in endform) {
        endform[key] = ''
      }
      this.specialDialog = false
      this.explanDialog = false
    },
    // 批量设置备注
    setSpecialExplan () {
      const { endform, batchFalg } = this
      if (!endform.explan && !batchFalg) {
        this.$nextTick(() => {
          this.explanDialog = true
          this.$message({
            message: '请填写备注',
            type: 'error'
          })
        })
        return
      }
      const ex = batchFalg ? 1 : 0
      // 提交通过
      this.submitBatchPass(ex)
    },
    // 批量提交
    submitBatchPass (ex) {
      const {
        checkSelected,
        tableData,
        endform
      } = this
      // 这里需要处理每条数据的有效期和备注
      checkSelected.forEach(item => {
        const index = tableData.findIndex(items => items.id === item.id)
        if (index !== -1) {
          tableData[index].state = ex
          tableData[index].specialDate = endform.endTime
          tableData[index].mark = endform.explan
        }
      })
      this.closeDialog()
    },
    verifyCheckResultData () {
      const tableData = this.data.customerSpecialPriceContentVoList
      for (var i = 0; i < tableData.length; i++) {
        const obj = tableData[i]
        if (obj.state !== 1 && obj.state !== 0) {
          return false
        } else if (obj.state === 1 && !obj.specialDate) {
          return false
        } else if (obj.state === 0 && !obj.mark) {
          return false
        }
      }
      return true
    },
    goProTypeDetail (item) {
      // 型号
      this.$router.push({
        name: 'productDetails',
        query: {
          id: item.proId
        }
      })
    },
    submitCheckResult () {
      if (this.verifyCheckResultData()) {
        // 这里可以提交数据
        this.specialApprovalVis = true
      } else {
        this.$message({
          message: '请确认所有产品审批结果，通过的必须设置特价结束时间，不通过的必须设置备注',
          type: 'error'
        })
      }
    },
    submitReq() {
      const { data } = this
      const tableData = this.data.customerSpecialPriceContentVoList
      const timer = 1000 * 60 * 60 * 24 - 1000
      tableData.forEach(item => {
        if (item.specialDate) {
          item.specialDate = new Date(new Date(item.specialDate).getTime() + timer)
        }
      })
      const params = {
        auditType: true,
        bizId: data.approvalId,
        bizRFId: 0,
        bizUrl: '',
        customerSpecialApprovalVo: {
          approvalId: data.approvalId,
          approvalState: data.approvalState,
          createDate: data.createDate,
          createIp: data.createIp,
          createUser: data.createUser,
          customerSpecialPriceManuaVoList: tableData,
          exPlain: data.exPlain,
          flag: true,
          id: data.id,
          mark: data.mark,
          obId: data.obId,
          orgId: data.orgId,
          ownId: data.ownId,
          state: data.state
        },
        loginUserId: 0,
        loginUserName: '',
        mark: '',
        nodeConditionMap: {}
      }
      specialofferApi.submitSpecialofferCheck(params).then(res => {
        if (isSuccess(res)) {
          const { cellcolor } = this
          const name = (cellcolor === '') ? 'specialoffercheckdetail' : 'specialofferlimitcheckdetail'
          this.$router.replace({
            name,
            query: {
              bizId: this.snaId
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    rowClass (row, index) {
      const { cellcolor } = this
      if (!row.aa && cellcolor !== '') {
        return { 'background-color': cellcolor }
      }
      return {}
    }
  }
}
</script>

<style
  scoped
  lang="less"
>

  /deep/ .el-tabs__header {
    margin: 0 !important;
  }

  /deep/ .el-tabs__content {
    display: none;
  }

  /deep/ .el-tabs__item {
    font-size: 18px;
    font-weight: bold;
  }
</style>
